__turbopack_context__.v({
  "action": "style-module-scss-module__JhVbAq__action",
  "actionBody": "style-module-scss-module__JhVbAq__actionBody",
  "actionLabel": "style-module-scss-module__JhVbAq__actionLabel",
  "activator": "style-module-scss-module__JhVbAq__activator",
  "card": "style-module-scss-module__JhVbAq__card",
  "chevron": "style-module-scss-module__JhVbAq__chevron",
  "description": "style-module-scss-module__JhVbAq__description",
  "glowWrapper": "style-module-scss-module__JhVbAq__glowWrapper",
  "icon": "style-module-scss-module__JhVbAq__icon",
  "iconWrap": "style-module-scss-module__JhVbAq__iconWrap",
  "opened": "style-module-scss-module__JhVbAq__opened",
  "panel": "style-module-scss-module__JhVbAq__panel",
  "panelInner": "style-module-scss-module__JhVbAq__panelInner",
  "panelSummary": "style-module-scss-module__JhVbAq__panelSummary",
  "signal": "style-module-scss-module__JhVbAq__signal",
  "summary": "style-module-scss-module__JhVbAq__summary",
  "title": "style-module-scss-module__JhVbAq__title",
  "toggle": "style-module-scss-module__JhVbAq__toggle",
  "toggleLabel": "style-module-scss-module__JhVbAq__toggleLabel",
});
